import * as yup from "yup";

const magazineSchema = yup.object().shape({
    name: yup.string().required("Este campo es requerido."),
    category: yup.number().moreThan(0,"Seleccione una categoría.").required("Este campo es requerido."),
    image: yup
        .number()
        .moreThan(0, "Seleccione una imagen")
        .required("Seleccione una imagen."),
    published: yup.number(),
    exportType: yup.string().oneOf(["system", "adobe"]).required("Seleccione un servicio para exportar la edición."),
});

export {
    magazineSchema
}